/**
 * Utility function to apply global styles to the document
 * This ensures no white space is visible when scrolling
 */
export const applyGlobalStyles = () => {
  if (typeof document !== 'undefined') {
    // Set document background color
    document.documentElement.style.backgroundColor = '#000000';
    document.body.style.backgroundColor = '#000000';
    
    // Prevent overscroll behavior that can show white space
    document.documentElement.style.overscrollBehavior = 'none';
    document.body.style.overscrollBehavior = 'none';
    
    // Ensure the document fills the viewport
    document.documentElement.style.minHeight = '100vh';
    document.body.style.minHeight = '100vh';
    
    // Hide overflow on x-axis to prevent horizontal scrolling
    document.documentElement.style.overflowX = 'hidden';
    document.body.style.overflowX = 'hidden';
  }
}; 